<template>
  <div class="p-4">
    <el-button icon="el-icon-close" size="small" v-if="showDeleteAll"
               @click="clearSelection()">Clear Selection</el-button>&nbsp;&nbsp;
    <el-button icon="el-icon-delete" type="danger" size="small" v-if="showDeleteAll"
               @click="deleteMultiple">Delete Selected</el-button>
    <button @click="$router.push('/ecommerce/customers/new')" class="float-right border-2 border-blue-500 text-blue-500 font-bold py-2 px-4 rounded">
      New Customer
    </button>
    <el-table
      ref="delCustomerTable"
      :data="customers.filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()))"
      :default-sort = "{prop: 'id', order: 'ascending'}"
      style="width: 100%"
      @select-all="handleAllRowSelection"
      @select="handleRowSelection">
      <el-table-column
        type="selection">
      </el-table-column>
      <el-table-column
        prop="name"
        label="Name"
        sortable>
        <template slot-scope="scope">{{scope.row.first_name}} {{scope.row.last_name}}</template>
      </el-table-column>
      <el-table-column
        prop="email"
        label="Email"
        sortable>
      </el-table-column>
      <el-table-column
        prop="phone"
        label="Phone"
        sortable>
      </el-table-column>
      <el-table-column
        prop="suspended"
        label="Suspended">
        <template slot-scope="scope">
          <span v-if="scope.row.suspended === true"><el-tag size="small" type="success">Yes</el-tag></span>
          <span v-else><el-tag size="small" type="danger">No</el-tag></span>
        </template>
      </el-table-column>
      <el-table-column
        prop="verified"
        label="Verified">
        <template slot-scope="scope">
          <span v-if="scope.row.verified === true"><el-tag size="small" type="success">Yes</el-tag></span>
          <span v-else><el-tag size="small" type="danger">No</el-tag></span>
        </template>
      </el-table-column>
      <el-table-column
        prop="created_at"
        label="Signed Up">
        <template slot-scope="scope">
          <span v-if="scope.row.created_at">{{scope.row.created_at | moment("from") }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" fixed="right">
        <template slot-scope="scope">
          <el-button @click="viewCustomer(scope.row.id)" type="text" size="small">
            <i class="text-xl text-gray-500 el-icon-view mr-1"></i>
          </el-button>
          <el-button @click="editCustomer(scope.row.id)" type="text" size="small">
            <i class="text-xl el-icon-edit-outline mr-4"></i>
          </el-button>
          <el-button @click="deleteCustomer(scope.row.id)" type="text" size="small">
            <i class="text-xl text-red-500 el-icon-delete-solid"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="mt-5 mb-5 float-right"
      background
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="handleSizeChange"
      @current-change="handlePageChange"
      :current-page="pagination.page"
      :page-size="pagination.perPage"
      :page-count="pagination.lastPage"
      :total="pagination.total">
    </el-pagination>
  </div>
</template>

<script>

import { flatMap } from 'lodash';

export default {
  name: 'Customers',
  data() {
    return {
      search: '',
      page: 1,
      limit: 20,
      showDeleteAll: false,
    };
  },
  computed: {
    customers() {
      return flatMap(this.$store.state.CustomerModule.customers);
    },
    pagination() {
      return this.$store.state.CustomerModule.pagination;
    },
  },
  mounted() {
    this.setBreadCrumbs(this.$route.meta.breadCrumbs);
  },
  methods: {
    handleRowSelection() {
      this.showDeleteAll = this.$refs.delCustomerTable.selection.length > 0;
    },
    handleAllRowSelection() {
      this.showDeleteAll = this.$refs.delCustomerTable.selection.length > 0;
    },
    clearSelection() {
      this.$refs.delCustomerTable.clearSelection();
      this.showDeleteAll = false;
    },
    viewCustomer(id) {
      this.$router.push(`/ecommerce/customers/${id}/details`);
    },
    editCustomer(id) {
      this.$router.push(`/ecommerce/customers/${id}/edit`);
    },
    deleteCustomer(customerId) {
      this.$confirm('Are you sure you want to delete this customer?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning',
      }).then(async () => {
        try {
          await this.$store.dispatch('CustomerModule/deleteCustomer', { customerId });
          this.$notify.success({
            title: 'Success',
            message: 'Customer has been deleted.',
          });
        } catch (e) {
          this.$notify.error({
            title: 'Error',
            message: 'Something went wrong please try again.',
          });
        }
      });
    },
    deleteMultiple() {
      const selected = this.$refs.delCustomerTable.selection.map(customer => customer.id);
      this.$confirm('Are you sure you want to delete these customer?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning',
      }).then(async () => {
        try {
          selected.forEach((customerId) => {
            this.$store.dispatch('CustomerModule/deleteCustomer', { customerId });
          });
          this.$notify.success({
            title: 'Success',
            message: 'Customer has been deleted.',
          });
        } catch (e) {
          this.$notify.error({
            title: 'Error',
            message: 'Something went wrong please try again.',
          });
        }
        this.clearSelection();
      });
    },
    getCustomers() {
      try {
        this.$store.dispatch('CustomerModule/fetchAllCustomers', { page: this.page, limit: this.limit });
      } catch (e) {
        this.$notify.error({
          title: 'Error',
          message: 'Something went wrong please try again.',
        });
      }
    },
    handleSizeChange(args) {
      this.limit = args;
      this.getCustomers();
    },
    handlePageChange(args) {
      this.page = args;
      this.getCustomers();
    },
  },
};
</script>

<style scoped>

</style>
